import React from 'react';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import Curriculum from '../components/Curriculum';
import Contrast from '../components/Contrast';
import Benefits from '../components/Benefits';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';

export default function Home() {
  return (
    <main>
      <Hero />
      <Problem />
      <Solution />
      <Curriculum />
      <Contrast />
      <Benefits />
      <Pricing />
      <FAQ />
    </main>
  );
}